module.exports = __webpack_public_path__ + "editor/icon-upload-4fb40138a587386c375ce110a8c11aa7.svg";